import * as z from "zod";

/**
 * Per-skill configuration. Keyed by SkillId in the parent map.
 * `enabled` controls whether the skill is active.
 */
export const SkillConfigSchema = z.object({ enabled: z.boolean().optional() });

export type SkillConfig = z.infer<typeof SkillConfigSchema>;
